<template>
  <v-speed-dial
    v-model="showDialButtons"
    bottom
    direction="top"
    fixed
    right
  >
    <template v-slot:activator>
      <v-btn
        v-model="showDialButtons"
        color="secondary darken-1"
        dark
        fab
      >
        <v-icon v-if="!showDialButtons">fal fa-filter</v-icon>
        <v-icon v-else>fal fa-times</v-icon>
      </v-btn>
    </template>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          :to="{ name: 'ReceiptsParked' }"
          class="mb-3"
          fab
          v-on="on"
        >
          <v-icon>fal fa-parking</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Parked Receipts') }}</span>
    </v-tooltip>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          :to="{ name: 'ReceiptsIndex' }"
          fab
          v-on="on"
        >
          <v-icon>fal fa-cash-register</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Receipts') }}</span>
    </v-tooltip>
  </v-speed-dial>
</template>

<script>
export default {
  name: 'ReceiptsFilterSpeedDial',

  data: () => ({
    showDialButtons: false
  })
}
</script>



// WEBPACK FOOTER //
// src/components/receipts/ReceiptsFilterSpeedDial.vue